module.exports = __webpack_public_path__ + "img/158.00963c57.jpg";